import { storeToRefs } from 'pinia'
import { useEditorStore } from '@/stores/editor.ts'

export function useDeleteTable() {
	function selector() {
		const selector = document.querySelector('.table--selector__overlay')

		if (selector) {
			selector.remove()
		}
	}

	function functionList(force = false) {
		const { isFunctionList, enterSelector } = storeToRefs(useEditorStore())
		const functionListContainer = document.querySelector('.table--function__list')

		if (functionListContainer && (!isFunctionList.value || force)) {
			isFunctionList.value = false
			if (enterSelector.value) {
				enterSelector.value.style.zIndex = '1'
				if (enterSelector.value.parentElement) {
					enterSelector.value.parentElement.style.zIndex = '1'
				}
			}
			functionListContainer.remove()
		}
	}

	return {
		selector,
		functionList,
	}
}
